module.exports = __webpack_public_path__ + "media/images/weather/256_night-0b09de1f49d46589323e08a04b308fd4.png";